import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { showNewToMeWePopup } from 'mewe/utils/dialogs-common';
import { isMobile } from 'mewe/shared/utils';
import { PUBLIC_ENTITY_TYPE } from 'mewe/constants';
import Storage from 'mewe/shared/storage';

export default class MwPublicView extends Component {

  @service account;
  @service dynamicDialogs;

  @tracked section = 'posts';

  isMobile = isMobile();

  constructor() {
    super(...arguments);

    this.setPageMeta();
  }

  setPageMeta() {
    document.title = __('To follow this page join or log-in to MeWe today');
  }

  @computed('args.model.contact.{id,nsfw,_links.avatar.nsfw,following,public}')
  get isNsfwBlurred() {
    if (this.args.model.contact.following) return false;
    const isNsfwAllowed = Storage.get(Storage.keys.allowNsfwContentSetting);
    if (this.args.model.contact.id === this.account.activeUser.id || isNsfwAllowed) return false;

    return this.args.model.contact._links?.avatar?.nsfw;
  }

  get isPublicProfile() {
    return this.args.model.entityType === PUBLIC_ENTITY_TYPE.PROFILE;
  }

  get isPublicPage() {
    return this.args.model.entityType === PUBLIC_ENTITY_TYPE.PAGE;
  }

  @action
  displayNewToMeWePopup() {
    showNewToMeWePopup(this.dynamicDialogs);
  }

  @action
  selectAbout() {
    this.section = 'about';
  }

  @action
  selectPosts() {
    this.section = 'posts';
  }
}
